import { createStateHook } from 'react-sweet-state';
import { store } from '../../main';
import type { IssueAdjustmentsState } from '../../types';

// remove useErrorCode with forge-ui-modifications-validation-errors-returned-to-app_hdzmw FF removal
export const useErrorCode = createStateHook(store, {
	selector: (state: IssueAdjustmentsState) => {
		if (state.error) {
			return state.error.errorCode;
		}
		return null;
	},
});
